export default __webpack_public_path__ + "static/media/2007-228x228.5569c598.png";